export const data = {
  description:
    "您在全球供应链中的战略合作伙伴，提供专业、高效且可靠的物流与货运解决方案。",
  address:
    "地址: Av. Balboa, Torre BAC, piso 13, oficina 2 Panamá, Panama City, Panama 0831",
  quick: "快速链接",
  aboutUs: "关于我们",
  services: "服务",
  contactUs: "联系我们",

  maritimeLaw: "海事法",
  taxLaw: "税法",
  customsLaw: "海关法",
  commercialLaw: "商业法",
  insurance: "保险",
  administrativeProcesses: "行政程序",
  stsOperations: "STS船对船操作",

  community: "社区",
  privacyPolicy: "隐私政策",
  termsAndConditions: "条款和条件",
};
